/** Font stack used for ROI pages, PDF report rendering, and ECharts labels. */
export const ROI_DISPLAY_FONT_FAMILY =
  "'Gotham', 'Noto Sans Arabic', Arial, sans-serif";
